export type DemoDomain =
  | "CUSTOMER_SUPPORT"
  | "CUSTOMER_SENSITIVE"
  | "FINANCE"
  | "TRADING"
  | "EMPLOYEE_HR"
  | "RISK_COMPLIANCE";
export type DemoResourceKey =
  | "support"
  | "employee"
  | "finance"
  | "risk"
  | "operations"
  | "supportWarehouse"
  | "customerPlatform";

interface DemoResourceMapping {
  key: DemoResourceKey;
  resource: string;
  domains: DemoDomain[];
}

/** Snapshot IDs are stable; only these explicit demo resource assignments carry domains. */
export const DEMO_SOURCE_MAPPINGS: Record<string, DemoResourceMapping[]> = {
  "8a488138a032c87801a032ea8c57014d": [
    {
      key: "support",
      resource:
        "Approved support tickets, case history and customer contact context",
      domains: ["CUSTOMER_SUPPORT"],
    },
  ],
  "8a48827da046f95401a047f197807ae7": [
    {
      key: "employee",
      resource: "Employee directory, payroll, compensation and benefits",
      domains: ["EMPLOYEE_HR"],
    },
  ],
  "8a48834e9ede5597019ede8ce4d305d4": [
    {
      key: "finance",
      resource: "Internal financial reporting, trading orders and history",
      domains: ["FINANCE", "TRADING"],
    },
  ],
  "8a4882ed9feee90a019fefd8fe570bb7": [
    {
      key: "risk",
      resource:
        "Risk metrics, KYC, AML and customer-sensitive analytical views",
      domains: ["RISK_COMPLIANCE", "CUSTOMER_SENSITIVE"],
    },
  ],
  // Snowflake Production
  "8a4883a28b341a56018b3746fb710183": [
    {
      key: "supportWarehouse",
      resource: "Customer support cases and ticket data",
      domains: ["CUSTOMER_SUPPORT"],
    },
  ],
  // Customer Data Platform
  "8a4881259d75a817019d760fe8d20811": [
    {
      key: "customerPlatform",
      resource: "Customer accounts, contacts and support interactions",
      domains: ["CUSTOMER_SUPPORT"],
    },
  ],
  "8a4881a19a16b032019a1737d5a862b3": [
    {
      key: "operations",
      resource: "Operational exceptions and aggregate analytical views",
      domains: ["RISK_COMPLIANCE"],
    },
  ],
};

/** Resource lookup derived from the source mapping; scenarios need not duplicate source IDs. */
export const DEMO_RESOURCE_BINDINGS = Object.fromEntries(
  Object.entries(DEMO_SOURCE_MAPPINGS).flatMap(([sourceId, resources]) =>
    resources.map(resource => [resource.key, { ...resource, sourceId }]),
  ),
) as Record<DemoResourceKey, DemoResourceMapping & { sourceId: string }>;
